import { DateTime } from 'luxon';

const rfc3339Date = 'yyyy-MM-dd';
const rfc3339DateTime = "yyyy-MM-dd'T'HH:mm:ss";

export function dateFromServer(serverDateTime: string): Date {
  return DateTime.fromISO(serverDateTime).toLocal().toJSDate();
}

export function dateTimeFromServer(serverDateTime: string): DateTime {
  return DateTime.fromISO(serverDateTime).toLocal();
}

/**
 *
 * @param value local time Javascript date
 * @returns property formatted UTC date
 */
export function dateToServer(value: Date): string {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return DateTime.fromJSDate(value).toUTC().toISO()!;
}

/**
 *
 * @param plusDays add days to today
 * @returns a date truncated to start of day, plus any days
 */
export function today(plusDays = 0): Date {
  return DateTime.local().startOf('day').plus({ days: plusDays }).toJSDate();
}

export function nowServer(): string {
  return dateStartOfDayToServer(new Date());
}

export function dateToDateTime(value: Date): DateTime {
  return DateTime.fromJSDate(value);
}
export function dateTimeToDate(value: DateTime): Date {
  return value.toJSDate();
}
export function dateTimeLongAgo(): DateTime {
  return DateTime.local().startOf('day').minus({ years: 10 });
}

export function dateTimeMinutesSince(aDate: DateTime) {
  return Math.abs(aDate?.diffNow().as('minutes') ?? 0);
}
export function dateTimeSecondsSince(aDate: DateTime) {
  return Math.abs(aDate?.diffNow().as('seconds') ?? 0);
}

/**
 *
 * @param value local date
 * @returns local datetime/date truncated to start of day and returned as UTC
 */
export function dateStartOfDayToServer(value: Date): string {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return DateTime.fromJSDate(value).startOf('day').toUTC().toISO()!;
}

/**
 * https://www.rfc-editor.org/rfc/rfc3339
 * @param localDateTime
 * @returns a formatted date suitable for using in Input[type=date].value
 */
export function dateToRFC3339(localDateTime: Date): string {
  return DateTime.fromJSDate(localDateTime).toLocal().toFormat(rfc3339Date);
}

/**
 * https://www.rfc-editor.org/rfc/rfc3339
 * @param localDateTime
 * @returns a formatted datetime suitable for using in Input[type=date].value
 */
export function dateAndTimeToRFC3339(localDateTime: Date): string {
  return DateTime.fromJSDate(localDateTime).toLocal().toFormat(rfc3339DateTime);
}

/**
 *
 * @param serverDateTime
 * @returns a formatted date suitable for using in Input[type=date].value
 */
export function dateFromServerToInputDateValue(serverDateTime: string): string {
  return dateToRFC3339(dateFromServer(serverDateTime));
}

export function dateFromServerToInputDateTimeValue(
  serverDateTime: string
): string {
  return dateAndTimeToRFC3339(dateFromServer(serverDateTime));
}

export function dateFromInputDateToServer(value: string): string {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return DateTime.fromFormat(value, rfc3339Date).toUTC().toISO()!;
}

export function dateFromInputDateTimeToServer(value: string): string {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return DateTime.fromFormat(value, rfc3339DateTime).toUTC().toISO()!;
}

// (function test() {
//     const serverDate = '2022-05-27T12:00:00.000Z';
//     const testDate = serverDateTimeToLocal(serverDate);
//     console.log('TEST Date Formatters');
//     console.log(
//         `server="${serverDate}" roundtrip="${localDateTimeToServer(testDate)}"`
//     );
//     console.log(`local date = "${testDate.toString()}"`);
//     console.log(
//         `local as Date to Server = "${localDateToServer(
//             testDate
//         )}" "${serverDateTimeToLocal(localDateToServer(testDate))}`
//     );
//     console.log(
//         `serverDate to Editor Value = "${serverDateToLocalRFC3339(serverDate)}"`
//     );
//     console.log(
//         `serverDateTime to Editor Value = "${serverDateTimeToLocalRFC3339(
//             serverDate
//         )}"`
//     );
//     console.log(
//         `localDate to Editor Value = "${localDateToRFC3339(testDate)}"`
//     );
//     console.log(
//         `localDateTime to Editor Value = "${localDateTimeToRFC3339(testDate)}"`
//     );
//
//     console.log(
//         `serverDateTime to Editor Value = "${serverDateTimeToLocalRFC3339(
//             serverDate
//         )}"`
//     );
//     console.log(
//         `serverDate to Editor Value = "${serverDateToLocalRFC3339(serverDate)}"`
//     );
//     console.log(
//         `Editor Date Value to Server = "${localRFC3339DateToServer(
//             serverDateToLocalRFC3339(serverDate)
//         )}"`
//     );
//     console.log(
//         `Editor DateTime Value to Server = "${localRFC3339DateTimeToServer(
//             serverDateTimeToLocalRFC3339(serverDate)
//         )}"`
//     );
//
//     console.log(testDate);
// })();
